import React, { FC, useState } from 'react';

import cn from 'classnames';
import { inject, observer } from 'mobx-react';

import { KikiLogo, LanguageSwitch, MenuDrawerSwitch, ProfilePopover } from '@components/Navbar/component';
import { Button } from '@element/index';
import { useClient, useIsomorphicLayoutEffect } from '@lib/hooks';
import { I18n } from '@utils/index';
import { openLoginAndRegister } from '@widget/loginRegister'

import styles from './navbar.module.less';

const theme = 'dark';

export const AirDropNavBarCom: FC<any> = (props) => {
  const {
    userStore: {
      socialUserInfo: {
        avatar
      },
      getUserSocialInfo,
      isLogin
    },
    isShow
  } = props
  const isPc = useClient();
  const [visible, setVisible] = useState(false);

  useIsomorphicLayoutEffect(() => {
    window.addEventListener('scroll', handBackgroundColor)
    return () => window.removeEventListener('scroll', handBackgroundColor)
  }, [isPc])

  const handBackgroundColor = (a) => {
    const opcity = document.documentElement.scrollTop /
      (document.getElementById('__next').clientHeight -
        document.body.clientHeight)
    const webnavbarDom: any =
    document.querySelector('#airdrop-navbar')
    webnavbarDom.style.background = `rgba(20, 20, 32, ${opcity})`
  }

  const handleLogin = () => {
    openLoginAndRegister({
      theme,
      cb: async ({ res }) => {
        const { jwtKey, id } = res || {}
        getUserSocialInfo({ userId: id, token: jwtKey });
      }
    });
  }
  return (
    <div className={styles.navabar} id="airdrop-navbar">
      <div className={styles.content}>
      <KikiLogo theme={theme} width='73px' height='26px'/>
      {
        isPc ? (<div className={styles.row}>
          {(!isLogin && isShow) && <div className={styles.row}>
            <div className={styles.desc}>{I18n.t('register_has_account')}</div>
            <Button
              className={cn(styles.login)}
              data-buried="login"
              data-name="kiki-navabar-web-btn-login"
              onClick={handleLogin}
            >
              {I18n.t('login')}
            </Button>
          </div>}
          <LanguageSwitch theme={theme} />
          <ProfilePopover avatar={avatar} isLogin={isLogin} isJumpLogin={false} />
        </div>
        ) : (
          <MenuDrawerSwitch
            visible={visible}
            setVisible={setVisible}
            theme={theme}
            isOnlyLogin={true}
            keys={['language']}
          />
        )
      }
      </div>
    </div>
  );
}

export const AirDropNavBar = inject((rootStore: { store: { userStore } }) => ({
  userStore: rootStore.store.userStore
}))(observer(AirDropNavBarCom));
